import { render, staticRenderFns } from "./TypeEvidenceCategory.vue?vue&type=template&id=091e6780&"
import script from "./TypeEvidenceCategory.vue?vue&type=script&lang=js&"
export * from "./TypeEvidenceCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports